import { createContext } from "react";

const BuildingContext = createContext({});

export default BuildingContext;